module.exports = __webpack_public_path__ + "static/media/duplicate.fc638264.svg";